/* eslint-disable array-callback-return */
export const screenRight = {
  buDashboard: "None",
  saDashboard: "None",
  myProfile: "Full Access",
  profile: "Full Access",
  makePayment: "Full Access",
  requests: "None",
  home: "None",

  SMSBack: "None",
  businessLocations: "None",
  notifications: "None",
  authorizationSettings: "None",
  generalSettings: "None",
  subscriptions: "None",

  userSettings: "None",

  settings: "None",
  roles: "None",
  users: "None",
  clients: "None",
  standardPlanFeatures: "None",
  subscriptionPlans: "None",
  parameterSettings: "None",
  templates: "None",
  reports: "None",
  clientsReport: "None",
  revenueReport: "None",
  paymentReport: "None",
  invoiceReport: "None",
  myUsers: "None",
  parameter: "None",
  businessUsers: "None",
  buRoles: "None",

  //gourav
  contacts: "None",
  expenses: "None",
  invoices: "None",
  debts: "None",
  RCTI: "None",
  credit: "None",
  debit: "None",
  uploadLegalDocument: "None",
  help: "None",
  reportBU: "None",
  invoiceReportBU: "None",
  quotationReportBU: "None",
  rctiReportBU: "None",
  agedReceivablesSummaryBU: "None",
  agedPayableSummaryBU: "None",
  contactReportBU: "None",
  expensesReportBU: "None",
  itemReportBU: "None",
  mysettings: "None",
  items: "None",
  categories: "None",
  defaultSetting: "None",
  debtCollection: "None",
  invoiceReminderLogs: "None",
  invoiceReminderTemplates: "None",
};

const defaultScreenRights = { ...screenRight };

export default function calculateRoleRights() {
  try {
    Object.assign(screenRight, defaultScreenRights);
    let ROLE_RIGHTS = JSON.parse(sessionStorage.getItem("ROLE_RIGHTS_LOGIN"));
    let ROLE = JSON.parse(sessionStorage.getItem("ROLE"));

    if (ROLE_RIGHTS) {
      if (ROLE_RIGHTS.length !== 0) {
        ROLE_RIGHTS.map((val) => {
          if (
            val.menuName === "Dashboard(BA)" &&
            ROLE.applicableForBusinessUser === "Yes"
          ) {
            if (val.screenRight !== "None")
              screenRight.buDashboard = val.screenRight;
            else screenRight.home = "Full Access";
          } else if (val.menuName === "Users") {
            screenRight.users = val.screenRight;
          } else if (val.menuName === "Parameter Settings") {
            screenRight.parameterSettings = val.screenRight;
          } else if (val.menuName === "Templates") {
            screenRight.templates = val.screenRight;
          } else if (val.menuName === "Parameter Lists") {
            screenRight.parameter = val.screenRight;
          } else if (val.menuName === "Reports" && val.screenRight !== "None") {
            screenRight.reports = val.screenRight;
            if (val.screenName === "Clients Report")
              screenRight.clientsReport = val.screenRight;
            else if (val.screenName === "Payment Report")
              screenRight.paymentReport = val.screenRight;
            else if (val.screenName === "Invoice Report")
              screenRight.invoiceReport = val.screenRight;
          } else if (val.menuName === "Categories") {
            screenRight.categories = val.screenRight;
          } else if (val.menuName === "Roles") {
            screenRight.roles = val.screenRight;
          } else if (val.menuName === "Standard Plan Features") {
            screenRight.standardPlanFeatures = val.screenRight;
          } else if (val.menuName === "Subscription Plans") {
            screenRight.subscriptionPlans = val.screenRight;
          } else if (val.menuName === "Dashboard(SA)") {
            screenRight.saDashboard = val.screenRight;
          } else if (val.menuName === "Upload Legal Document") {
            screenRight.uploadLegalDocument = val.screenRight;
          } else if (
            val.menuName === "Business Users" &&
            ROLE.applicableForBusinessUser === "No"
          ) {
            if (val.screenRight !== "None")
              screenRight.businessUsers = val.screenRight;
            else screenRight.home = "Full Access";
          } else if (val.menuName === "Contacts") {
            screenRight.contacts = val.screenRight;
          } else if (val.menuName === "Quotations") {
            screenRight.quotations = val.screenRight;
          } else if (val.menuName === "Invoices") {
            screenRight.invoices = val.screenRight;
          } else if (val.menuName === "RCTI") {
            screenRight.RCTI = val.screenRight;
          } else if (val.menuName === "Credit Notes") {
            screenRight.credit = val.screenRight;
          } else if (val.menuName === "Debit Notes") {
            screenRight.debit = val.screenRight;
          } else if (val.menuName === "Expenses") {
            screenRight.expenses = val.screenRight;
          } else if (val.menuName === "Help") {
            screenRight.help = val.screenRight;
          } else if (
            val.menuName === "Debt Collection" &&
            val.screenRight !== "None"
          ) {
            screenRight.debtCollection = val.screenRight;

            if (val.screenName === "Invoice Reminder Logs") {
              screenRight.invoiceReminderLogs = val.screenRight;
            } else if (val.screenName === "Debts") {
              screenRight.debts = val.screenRight;
            } else if (val.screenName === "Invoice Reminder Templates") {
              screenRight.invoiceReminderTemplates = val.screenRight;
            }
          } else if (
            val.menuName === "Report BU" &&
            val.screenRight !== "None"
          ) {
            screenRight.reportBU = val.screenRight;
            if (val.screenName === "Invoice Reports") {
              screenRight.invoiceReportBU = val.screenRight;
            } else if (val.screenName === "Quotation Reports") {
              screenRight.quotationReportBU = val.screenRight;
            } else if (val.screenName === "RCTI Reports") {
              screenRight.rctiReportBU = val.screenRight;
            } else if (val.screenName === "Aged Payables Summary") {
              screenRight.agedPayableSummaryBU = val.screenRight;
            } else if (val.screenName === "Aged Receivables Summary") {
              screenRight.agedReceivablesSummaryBU = val.screenRight;
            } else if (val.screenName === "Contact Reports") {
              screenRight.contactReportBU = val.screenRight;
            } else if (val.screenName === "Expense Reports") {
              screenRight.expensesReportBU = val.screenRight;
            } else if (val.screenName === "Item Reports") {
              screenRight.itemReportBU = val.screenRight;
            }
          } else if (
            val.menuName === "BU_Settings" &&
            val.screenRight !== "None"
          ) {
            screenRight.mysettings = val.screenRight;
            if (val.screenName === "Default Setting") {
              screenRight.defaultSetting = val.screenRight;
            } else if (val.screenName === "Subscriptions") {
              screenRight.subscriptions = val.screenRight;
            } else if (val.screenName === "My Users") {
              screenRight.myUsers = val.screenRight;
            } else if (val.screenName === "User Roles") {
              screenRight.buRoles = val.screenRight;
            } else if (val.screenName === "Items") {
              screenRight.items = val.screenRight;
            } else if (val.screenName === "Invoice Reminder Templates") {
              screenRight.invoiceReminderTemplates = val.screenRight;
            }
          }
        });
      }
    } else {
      screenRight.customerOrders = "Full Access";
    }
  } catch (error) {
    console.log("error in calculateRoleRights=", error);
  }
}
